import React from 'react';

/**
 * Minimální formátování textů, které se dají psát v administraci:
 *   prázdný řádek  → nový odstavec
 *   `text`         → inline kód
 * Záměrně nic víc – žádné HTML z databáze se nikdy nevkládá do stránky.
 */
function inline(text) {
  return text.split(/(`[^`]+`)/g).filter(Boolean).map((part, index) =>
    part.startsWith('`') && part.endsWith('`') && part.length > 2
      ? <code className="icode" key={index}>{part.slice(1, -1)}</code>
      : <React.Fragment key={index}>{part}</React.Fragment>,
  );
}

export function RichText({ text, className }) {
  if (!text) return null;
  const paragraphs = String(text).split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean);

  return (
    <div className={className}>
      {paragraphs.map((paragraph, index) => (
        <p key={index}>{inline(paragraph)}</p>
      ))}
    </div>
  );
}

export default RichText;
